module.exports = __webpack_public_path__ + "static/media/Aragon-Research-Hot-Vendor-2020-Transparent.e583da95.png";